import { PropsWithChildren } from 'react';

import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';

import { ModulePageConfigContext } from './ModulePageConfigProvider.context';
import { useModulePageConfigFetch } from './ModulePageConfigProvider.hook';

export const ModulePageConfigProvider = ({ children }: PropsWithChildren) => {
  const { loading, modules } = useModulePageConfigFetch();
  if (loading) {
    return <CircularProgressCentered color="inherit" />;
  }
  return <ModulePageConfigContext.Provider value={modules}>{children}</ModulePageConfigContext.Provider>;
};
